<template>
  <div>
    <modal modal-id="add-order" animation="fadeInRight">
      <div slot="title">Add Order</div>
      <div slot="form">
        <div class="row">
          <div class="col-lg-3">Name</div>
          <div class="col-lg-9">
            <input type="text" name="" class="form-control" placeholder="Name" v-model="formData['name']">
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3">Client</div>
          <div class="col-lg-9">
            <v-select :options="f.clients" index="id" label="name" v-model="formData['client']" @change="formData['filters'] = {}"></v-select>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3">Actions</div>
          <div class="col-lg-9">
            <v-select :options="this.types" :multiple="true" index="id" v-model="formData['types']"></v-select>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3">Start</div>
          <div class="col-lg-9">
            <input type="date" name="" class="form-control" placeholder="Start date" v-model="formData['start']">
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3">End</div>
          <div class="col-lg-9">
            <input type="date" name="" class="form-control" placeholder="End date" v-model="formData['end']">
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3">Credits</div>
          <div class="col-lg-9">
            <input type="number" min="0" class="form-control" placeholder="Number of credits" v-model.number="formData['credits']">
          </div>
        </div>
        <div class="row m-t-md">
          <div class="col-lg-3"><h4>Filters</h4></div>
          <div class="col-lg-9">
          </div>
        </div>
        <div class="row" v-if="formData['client']">
          <div class="col-lg-3">Clients</div>
          <div class="col-lg-9">
            <v-select :options="f.clients" index="id" label="name" :multiple="true" v-model="formData['filters']['clients']"></v-select>
          </div>
          <div class="col-lg-3">Groups</div>
          <div class="col-lg-9">
            <v-select :options="f.groupsByClient[formData['client']]" index="id" label="name" :multiple="true" v-model="formData['filters']['groups']"></v-select>
          </div>
          <div class="col-lg-3">Groups Not</div>
          <div class="col-lg-9">
            <v-select :options="f.groupsByClient[formData['client']]" index="id" label="name" :multiple="true" v-model="formData['filters']['groupsNot']"></v-select>
          </div>
        </div>
        <div class="row m-t-sm">
          <div class="col-lg-3"></div>
          <div class="col-lg-9">
            <button class="btn btn-sm btn-primary" @click="addOrder">Add</button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import Modal from '../../Helpers/Modal/Form'
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  data () {
    return {
      formData: {
        filters: {}
      },
      types: [
        {
          id: 'build',
          label: 'Build'
        },
        {
          id: 'link',
          label: 'Link'
        },
        {
          id: 'fix',
          label: 'Fix'
        },
        {
          id: 'content',
          label: 'Content'
        }
      ]
    }
  },
  mounted () {
    if (!this.f.length) {
      this.$store.dispatch('loadFilters')
    }
  },
  components: {
    modal: Modal
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  methods: {
    addOrder () {
      let data = this.formData
      axios.post('/maintenance/order', data)
        .then(r => {
          this.$store.dispatch('loadMaintenanceOrders')
          this.formData = {
            filters: {}
          }
          $('#add-order').modal('hide')
          this.$toastr.success('Order added')
        }).catch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/MaintenanceOrder/AddOrderModal.vue